export default "__VITE_ASSET__DKvKozuY__$_?nuxt_component=async&nuxt_component_name=IUsdgColorLogoThreadsIcon__"